export default __webpack_public_path__ + "germany.f34680fc.png";